import { AssetType } from "@validereinc/domain";

export const AssetTypeSelection = {
  ...AssetType,
  ALL_ASSETS: "all_assets",
} as const;
export type AssetTypeSelectionType =
  (typeof AssetTypeSelection)[keyof typeof AssetTypeSelection];
